const apiUrl = process.env.REACT_APP_API_URL;
export const PostAlgoritmix = async (formData : FormData , page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/algoritmix`, {
            method: 'POST',
            headers: {
                // No es necesario definir el encabezado 'content-type' aquí
                'pantalla': page,
            },
            body: formData
        });

        const jsonData = await response.json();
        return jsonData;

    } catch (error) {
        console.error('Error al cargar el archivo', error);
    }
};
